export default __webpack_public_path__ + "static/media/chat.8c6b048a.svg";